import React, { useContext } from 'react'

import Button, { NoBackgroundButton } from '../../../../../components/Button'

import contractContext from '../../../../../store/contexts/contractContext'
import CONTRACT_ACTIONS from '../../../../../store/actions/contractActions'

import { useCommonStyles } from '../../../../../styles/globalStyles'
import { WARRANTY_TYPE } from '../../../../../constants/warrantyType'
import Details from './components/Details'

const WarrantyDetails = () => {
  const commonClasses = useCommonStyles()
  const {
    proposition: { propositionDispatch },
    handleStepChange,
  } = useContext(contractContext)

  const handleSetInsurance = () => {
    propositionDispatch({
      type: CONTRACT_ACTIONS.SET_TYPE,
      value: WARRANTY_TYPE.DEPOSIT,
    })

    handleStepChange('NumberOfDeposits')
  }

  return (
    <div>
      <p className={commonClasses.contractSubtitle}>
        Confira todos os detalhes sobre o seguro com caução de entrada.
      </p>
      <Details />
      <div className='end-aligner'>
        <NoBackgroundButton title='Voltar' onClick={() => handleStepChange('NegotiatedConditions')} />
        <Button title='CONFIRMAR' onClick={handleSetInsurance} />
      </div>
    </div>
  )
}

export default WarrantyDetails
